
import React, {
  useEffect,
  useState,
} from 'react'
import ProgressiveImage from 'react-progressive-image'

import { sizes } from 'constants/media'

import StartQuoteButton from 'components/base/StartQuoteButton'

import { Theme } from '../../types'

import { Props } from './types'

import Image, {
  bgImages,
  CallToAction,
  CallToActionTitle,
  NoImage,
  ContentWrap,
  LargeTitle,
} from './styles'

const PageHeroImage: React.FC<Props> = ({
  children,
  cta = false,
  ctaShowExternalIcon = false,
  ctaText = 'Start a Quote',
  ctaTitle,
  ctaUrl = '/quote/new',
  right = false,
  isLargeHeight = false,
  hasOpacity = false,
  hasLargeTitle = false,
  largeTitle,
  theme,
  trackingInfo,
  ...props
}): React.ReactElement => {
  const image = bgImages[theme.charAt(0).toUpperCase() + theme.slice(1)]

  const [
    selectedImage,
    setSelectedImage,
  ] = useState((image && image.medium) || undefined)

  useEffect(() => {
    if (!image) {
      return
    }

    const onMediaQuery = (mediaQueryMedium: MediaQueryList | MediaQueryListEvent): void => {
      if (mediaQueryMedium.matches) {
        setSelectedImage(image.medium)
      }
      else {
        setSelectedImage(image.small)
      }
    }

    const mediaQueryMedium = window.matchMedia(`(min-width: ${sizes.medium}px)`)
    onMediaQuery(mediaQueryMedium)
    mediaQueryMedium.addListener(onMediaQuery)
  }, [ image ])

  if (theme === Theme.noimage) {
    return <NoImage>{children}</NoImage>
  }

  return (
    <ProgressiveImage
      src={selectedImage.src}
      placeholder={selectedImage.placeholder}
    >
      {(src: string, loading: boolean): React.ReactElement => (
        <Image
          {...props}
          bgPosition={selectedImage.bgPosition}
          isLoading={loading}
          right={right}
          bgImage={src}
          isLargeHeight={isLargeHeight}
        >
          <ContentWrap hasOpacity={hasOpacity}>
            {hasLargeTitle && (
              <LargeTitle>{largeTitle}</LargeTitle>
            )}
            {children}
            {cta && (
              <CallToAction>
                {ctaTitle && (
                  <CallToActionTitle>{ctaTitle}</CallToActionTitle>
                )}
                <StartQuoteButton
                  trackingInfo={{
                    button_position: 'top',
                    ...trackingInfo,
                  }}
                  showExternalIcon={ctaShowExternalIcon}
                  to={ctaUrl}
                >
                  {ctaText}
                </StartQuoteButton>
              </CallToAction>
            )}
          </ContentWrap>
        </Image>
      )}
    </ProgressiveImage>
  )
}

export * from './types'

export default PageHeroImage
